<template>
  <v-dialog v-if="values.showDialog"  v-model="values.showDialog" persistent scrollable width="500">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Relatório de Tarefas
      </v-card-title>
      <v-card-text>
        <v-form autocomplete="off" @submit.prevent="" v-model="valid" ref="form">
          <v-layout wrap justify-left align-center>
            <v-flex xs12>
              <v-flex xs12>
                <v-text-field v-if="values.selectedTask" ref="tasksIllis" disabled 
                :label="translate('table.tasks.title')[0]" :value="values.reportDialogEditedItem.id_text" style="word-break: break-all;">
                </v-text-field>
                <p-tasks-illis v-else ref="tasksIllis" :disabled="values.disableTasks" v-model="values.reportDialogEditedItem.task_id" :label="translate('table.tasks.title')[0]" :rules="requiredRule(translate('table.tasks.title')[0])" style="word-break: break-all;">
                </p-tasks-illis>
              </v-flex>
            </v-flex>
            <v-flex elevation-1>
              <h4>Período do Relatório</h4>
              <v-layout row wrap>
                <v-flex xs6>
                  <p-date-time label="Início"
                              v-model="values.reportDialogEditedItem.begin"
                              :disabled="!checkPlanAccess('reports_everyday', 'has')"
                              :defaultHour="'00:00'"
                              :rules="dateDiffRule(false, 'data', this.values.reportDialogEditedItem.begin, this.values.reportDialogEditedItem.end)">
                  </p-date-time>
                </v-flex>
                <v-flex xs6>
                  <p-date-time label="Fim"
                              v-model="values.reportDialogEditedItem.end"
                              :disabled="!checkPlanAccess('reports_everyday', 'has')"
                              :defaultHour="'23:59'"
                              :rules="dateDiffRule(false, 'data', this.values.reportDialogEditedItem.begin, this.values.reportDialogEditedItem.end)">
                  </p-date-time>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs4>
              <v-checkbox
                v-model="comments"
                label="Comentários"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4>
              <v-checkbox
                v-model="files"
                label="Arquivos"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4>
                <v-checkbox
                  v-model="checklists"
                  label="Listagens"
                ></v-checkbox>
            </v-flex>
            <v-flex xs4>
                <v-checkbox
                  v-model="durations"
                  label="Durações"
                ></v-checkbox>
            </v-flex>
            <v-flex xs4>
              <v-checkbox
                v-model="users"
                label="Participantes"
              ></v-checkbox>
            </v-flex>
            <v-flex xs4>
              <v-checkbox
                v-model="subtasks"
                label="Subtarefas"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12>
              <v-checkbox
              v-model="showEmptyCustomFields"
                label="Mostrar campos personalizados vazios"
              ></v-checkbox>
            </v-flex>
            <v-flex xs12>
              <v-checkbox
              v-model="send"
                label="Enviar para os participantes"
              ></v-checkbox>
            </v-flex>

          </v-layout>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="mx-1" :loading="loading" color="primary darken-1" @click='openReport(1)'>PDF</v-btn>
        <v-btn class="mx-1" :loading="loading" color="primary darken-2" @click='openReport(2)'>Excel</v-btn>
        <v-btn class="mx-1" :loading="loading" @click="close">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import rules from './../../mixin/rules'
  import plan from './../../mixin/plan'
  import PDateTime from './../shared/PDateTime'
  import PDate from './../shared/PDate'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format'
  import PTasksIllis from './../shared/PTasksIllis'

  momentDurationFormatSetup(moment)
  export default {
    mixins: [rules, plan],
    name: 'PTasksFather',
    components: {
      PTasksIllis,
      PDateTime,
      PDate
    },
    data: () => ({
      valid: false,
      checklists: true,
      files: true,
      users: true,
      showEmptyCustomFields: true,
      send: false,
      subtasks: true,
      comments: true,
      durations: true,
      defaultItem: {task_id: '', begin: '', end: '', id_text: ''},
      entity: 'tasks',
      loading: false
    }),
    methods: {
      openReport: function (type) {
        if (!this.$refs.form.validate() || !this.$refs.tasksIllis.validate()) {
          this.$store.commit('snackbar/change_values', {
            text: 'Por favor, corrija as validações antes de salvar!',
            color: 'error',
            dialog: true
          })
          return false
        }
        let params = 'task_id=' + this.values.reportDialogEditedItem.task_id
        if (this.values.reportDialogEditedItem.begin !== '') {
          params = params + '&begin=' + this.values.reportDialogEditedItem.begin
        } else {
          params = params + '&begin=' + null
        }
        if (this.values.reportDialogEditedItem.end !== '') {
          params = params + '&end=' + this.values.reportDialogEditedItem.end
        } else {
          params = params + '&end=' + null
        }
        params = params + '&checklists=' + this.checklists + '&durations=' + this.durations + '&users=' + this.users + '&files=' + this.files + '&comments=' + this.comments + '&subtasks=' + this.subtasks + '&send=' + this.send + '&showEmptyCustomFields=' + this.showEmptyCustomFields
        if (type === 1) {
          params = params + '&type=' + 1
        } else {
          params = params + '&type=' + 2
        }
        this.$store.commit('loader/change_dialog', true)
        this.loading = true
        this.$http.get(`api/report/task/father?${params}`).then(res => {
          let fileName = res.bodyText
          window.open(process.env.API + 'uploads/reports/' + fileName, '_blank')
          let _this = this
          setTimeout(function () {
            _this.$http.delete(`api/delete_upload_report/${fileName}`)
          }, 5000)
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
        }, (err) => {
          if (err.body.message === 'accessDenied') {
            this.$store.commit('snackbar/change_values', {timeout: 12000, text: 'Você não possui acesso para esse relatório.', color: 'warning', dialog: true})
          } else {
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível abrir esse relatório, reporte o erro.', color: 'error', dialog: true})
            alert('Erro! Falha ao enviar a requisição.')
          }
          this.$store.commit('loader/change_dialog', false)
          this.loading = false
        })
      },
      close: function () {
        this.$store.commit('reportDialog/change_values', { showDialog: false, disableTasks: false })
        this.send = false
        this.showEmptyCustomFields = true
        Object.assign(this.values.reportDialogEditedItem, JSON.parse(JSON.stringify(this.defaultItem)))
      }
    },
    computed: {
      values () {
        return this.$store.getters[`reportDialog/values`] || ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/reports/PTaskFather.vue